<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <multi-list-select
      :id="id"
      v-model="selected"
      :list="options"
      :option-value="value"
      :placeholder="placeholder"
      :custom-text="customText"
      class="form-select"
      :selected-items="selected"
      @select="onSelect"
    />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import 'vue-search-select/dist/VueSearchSelect.css'
import { MultiListSelect } from 'vue-search-select'
import { v4 as uuid } from 'uuid'

export default {
  components: { MultiListSelect,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `search-multi-select-input-${uuid()}`
      },
    },
    options: {
      required: true,
      type: Array,
    },
    placeholder: {
      default: 'Select Item',
      type: String,
    },
    modelValue: [Object, String, Number, Boolean],
    value: String,
    text: String,
    error: String,
    label: String,
    customText: Function,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.modelValue,
      lastSelectItem: {},
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected ?? null)

      return selected
    },
  },
  methods: {
    /**
     * Refreshing by value.
     *
     * @param refreshValue
     */
    refreshSelected(refreshValue = null) {
      this.selected = refreshValue
    },

    /**
     * Select event.
     *
     * @param items
     * @param lastSelectItem
     */
    onSelect(items, lastSelectItem) {
      this.selected = items
      this.lastSelectItem = lastSelectItem
    },
  },
}
</script>